/* eslint jsx-a11y/click-events-have-key-events: 0, jsx-a11y/no-noninteractive-element-interactions: 0 */

import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import LabelAsHTML from './LabelAsHTML';
import { moreDetailsEvent } from '../utils/analytics';
import { setClassNames } from '../utils/utility';
import { CaDisclaimer } from './CanadaDisclaimerContent';
import { PLEASE_CALL, DETAILS } from '../constants/labels';

export default class PricingDetail extends React.Component {
	// old VDP used to implement a flag called showCategory which was used to
	// determine if we should show conditional incentive type inline.  so it might
	// append 'military' or 'college' to the incentive title if it's set to true.
	// leaving this comment because it was removed as a check to show the descriptive label
	// but might be implemented again in the future and it's not documented anywhere else
	static getLabel({ price, prefs, labels, locale }) {
		const {
			title,
			shortTitle,
			typeClass,
			isFinalPrice,
			incentiveId
		} = price;
		let { label } = price;
		// Conditional final price label is coming from BE as a label ID and not a translated label.
		// TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.
		if (label === 'CONDITIONAL_FINAL_PRICE') {
			label = labels.get('CONDITIONAL_FINAL_PRICE');
		}

		const titlePref = prefs.incentiveTitleDisplay;
		let incentiveLabel = label;

		if (incentiveId) {
			if (title && title[locale] && titlePref === 'regular') {
				incentiveLabel = title[locale];
			}
			if (
				shortTitle &&
				shortTitle[locale] &&
				titlePref === 'descriptive'
			) {
				incentiveLabel = shortTitle[locale];
			}
			if (
				titlePref === 'custom' &&
				typeClass === 'discount' &&
				!isFinalPrice
			) {
				incentiveLabel = labels.get(prefs.incentiveTitleCustom);
			}
		}

		return incentiveLabel;
	}

	showModal(incentiveId) {
		const { incentiveData } = this.props;
		const incentiveDetails = incentiveData.find(incentive => {
			return incentive.key === incentiveId;
		});
		const { windowId, widgetName } = this.props.widgetInfo;
		moreDetailsEvent(widgetName, windowId, 'Details');
		this.props.setModalStateData(incentiveDetails, true);
	}

	render() {
		const {
			detail,
			detailType,
			prefs: { priceDiscountColor, finalPriceSize, finalPriceColor },
			locale,
			dealerAddress,
			isFinalPriceFlagEnabled
		} = this.props;

		const { deviceType, vehicleType } = this.props.widgetInfo;
		const isMobile = deviceType === 'MOBILE';
		let adjustmentDetected = false;
		const vehicleTypeClass = vehicleType
			? `inv-type-${vehicleType.toLowerCase()}`
			: '';

		return (
			<dl
				className={setClassNames(
					'pricing-detail',
					'line-height-condensed',
					'mb-4',
					vehicleTypeClass
				)}
			>
				{detail.map(price => {
					const {
						_type,
						incentiveId,
						formatted,
						isFinalPrice,
						shortLabel,
						showCategory
					} = price;
					let { typeClass } = price;
					let formattedValue = formatted;
					let valueClass = '';

					if (formattedValue === PLEASE_CALL) {
						valueClass = 'no-value';
						formattedValue = (
							<Common
								render={({ labels }) => {
									return labels.get(PLEASE_CALL);
								}}
							/>
						);
					}

					const isStackedFinal = _type === 'SICF' || _type === 'SIF';
					const isPlusMinus = _type === '-' || _type === '+';
					const isSubtractedTypes = [
						'-', // Discount
						'SICI', // Stack Itemized Cash Incentive
						'SICCI', // Stack Itemized Conditional Cash Incentive
						'SICNI', // Stack non-Itemized Cash Incentives
						'SICCNI', // Stack non-Itemized Conditional Cash Incentive
						'CCIC' // Conditional Category Incentive Cash
					];
					const isSubtracted = isSubtractedTypes.includes(_type);
					const isTotal =
						_type === 'TOTAL' || // Represents the last price in the rule
						_type === 'SICF' || // Final price including conditional incentives
						_type === 'SIF' || // Final price including stack incentives
						isFinalPrice;

					let isEpriceFinal;
					// Remove when removing flag
					if (isFinalPriceFlagEnabled) {
						// Keep the next line when removing flag and make isEpriceFinal a const
						isEpriceFinal =
							detailType === 'ePrice' && _type === 'TOTAL';
					} else {
						isEpriceFinal = detailType === 'ePrice' && isFinalPrice;
					}
					const isIncentive = !!incentiveId;

					const incentiveLinkMarkup = (
						<button
							className={setClassNames(
								'text-link',
								'd-block',
								isMobile
									? 'ddc-font-size-small'
									: 'ddc-font-size-xsmall'
							)}
						>
							<Common
								render={({ labels }) => {
									return labels.get(DETAILS);
								}}
							/>
						</button>
					);

					const lineBreakMarkup = (
						<dd
							className="pricing-divider my-3"
							key={`${_type}-divider`}
						/>
					);

					let hasLineBreak = false;
					let subtractedValueClass = '';
					let totalValueClass = '';
					let ePriceClass = '';
					let formattedPrice = formattedValue;
					let canadaDisclaimerMarkup = null;

					if (isStackedFinal) {
						hasLineBreak = true;
					}

					if (isPlusMinus) {
						adjustmentDetected = true;
						hasLineBreak = false;
					} else {
						if (adjustmentDetected === true) {
							hasLineBreak = true;
						}
						adjustmentDetected = false;
					}

					if (isSubtracted) {
						if (formatted === PLEASE_CALL) {
							formattedPrice = formattedValue;
						} else {
							formattedPrice = isMobile
								? `- ${formattedValue}`
								: `-${formattedValue}`;
							subtractedValueClass = `${priceDiscountColor}`;
						}
					}

					if (isTotal) {
						totalValueClass = 'font-weight-bold';
					}
					if (isEpriceFinal) {
						ePriceClass = 'eprice';
					}

					if (isFinalPrice) {
						typeClass = 'final-price';
						totalValueClass = `${totalValueClass} ${finalPriceColor}`;

						// suppressing finalPriceSize for final pricing that contains PLEASE_CALL value
						if (formatted !== PLEASE_CALL) {
							totalValueClass = `${totalValueClass} ${finalPriceSize}`;
							canadaDisclaimerMarkup = (
								<CaDisclaimer dealerAddress={dealerAddress} />
							);
						}
					}

					const isStyleEditable =
						vehicleTypeClass !== '' && typeClass !== '';

					return [
						hasLineBreak ? lineBreakMarkup : '',
						<dt
							data-style-editor-price={
								isStyleEditable ? 'true' : null
							}
							className={setClassNames(
								isIncentive ? 'pointer' : '',
								isStyleEditable ? typeClass : ''
							)}
							onClick={() =>
								isIncentive
									? this.showModal(incentiveId)
									: false
							}
							key={`${_type}-dt`}
						>
							<Common
								render={({ prefs, labels, flags }) => {
									let label;

									// TODO: restore tests in PricingDetail.test.jsx after this flag is removed
									if (
										flags[
											'ws-detailed-pricing-show-alternate-incentive-titles'
										]
									) {
										label = PricingDetail.getLabel({
											price,
											prefs,
											labels,
											locale
										});
									} else {
										// conditional for setting label.
										label =
											shortLabel &&
											showCategory === true &&
											shortLabel[locale]
												? shortLabel[locale]
												: price.label;
									}

									return (
										<LabelAsHTML
											{...{
												label,
												isStyleEditable,
												typeClass,
												vehicleTypeClass
											}}
										/>
									);
								}}
							/>
							{isIncentive ? incentiveLinkMarkup : ''}
						</dt>,
						<dd
							data-style-editor-price={
								isStyleEditable ? 'true' : null
							}
							onClick={() =>
								isIncentive
									? this.showModal(incentiveId)
									: false
							}
							className={setClassNames(
								subtractedValueClass,
								totalValueClass,
								ePriceClass,
								isIncentive ? 'pointer' : '',
								isStyleEditable ? typeClass : ''
							)}
							key={`${_type}-dd`}
						>
							<span
								className={setClassNames(
									'price-value',
									valueClass
								)}
								data-style-editor-id={
									isStyleEditable
										? `vdp-${typeClass}-price-value`
										: null
								}
								data-style-editor-text={
									isStyleEditable
										? `.vdp .${vehicleTypeClass}.pricing-detail .${typeClass} .price-value`
										: null
								}
							>
								{formattedPrice}
							</span>
						</dd>,
						canadaDisclaimerMarkup
					];
				})}
			</dl>
		);
	}
}

PricingDetail.propTypes = {
	detail: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			typeClass: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
			isFinalPrice: PropTypes.bool,
			incentives: PropTypes.arrayOf(PropTypes.string),
			showCategory: PropTypes.bool
		})
	).isRequired,
	detailType: PropTypes.string,
	incentiveData: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			error: PropTypes.string
		}).isRequired
	).isRequired,
	widgetInfo: PropTypes.shape({
		deviceType: PropTypes.string.isRequired,
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		vehicleType: PropTypes.string.isRequired
	}).isRequired,
	setModalStateData: PropTypes.func.isRequired,
	prefs: PropTypes.shape({
		priceDiscountColor: PropTypes.string,
		finalPriceSize: PropTypes.string,
		finalPriceColor: PropTypes.string
	}).isRequired,
	locale: PropTypes.string,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	}),
	isFinalPriceFlagEnabled: PropTypes.bool.isRequired
};

PricingDetail.defaultProps = {
	detailType: '',
	locale: 'en_US',
	dealerAddress: {}
};



// WEBPACK FOOTER //
// ./src/components/PricingDetail.jsx